module.exports = __webpack_public_path__ + "img/Neighborhood.0be3d7ce.png";